import React from "react";
import { noop } from "lodash";
import PropTypes from "prop-types";

import ContactInfo from "src/shared/contact-boxes/components/ContactInfo";
import contactProps from "src/shared/utilities/graphql/contactProps";

import * as S from "./styled";

const ContactField = ({
  className,
  contact,
  dealType,
  isMobile,
  onChange,
  onInfoClick,
  recentDealsCount,
  recentDealsCountPostfix,
  ...props
}) => (
  <S.ContactFieldWrapper className={className}>
    <ContactInfo
      contact={contact}
      dealType={dealType}
      hidePhone
      isMobile={isMobile}
      onInfoClick={onInfoClick}
      recentDealsCount={recentDealsCount}
      recentDealsCountPostfix={recentDealsCountPostfix}
      {...props}
    />
  </S.ContactFieldWrapper>
);

ContactField.propTypes = {
  className: PropTypes.string,
  contact: PropTypes.shape(contactProps).isRequired,
  dealType: PropTypes.string,
  isMobile: PropTypes.bool,
  isNewAgentProfileEnabled: PropTypes.bool,
  onChange: PropTypes.func,
  onInfoClick: PropTypes.func,
  recentDealsCount: PropTypes.number,
  recentDealsCountPostfix: PropTypes.string
};

ContactField.defaultProps = {
  className: "",
  dealType: "recent",
  isMobile: false,
  isNewAgentProfileEnabled: false,
  onChange: noop,
  onInfoClick: noop,
  recentDealsCount: null,
  recentDealsCountPostfix: null
};

export default ContactField;
